'use client';
import { Badge } from '@ethsign/ui';
import { cva } from 'class-variance-authority';
import classNames from 'classnames';
import { ReactNode, useMemo } from 'react';

import { NETWORK_TYPE_DISPLAY } from '@/constants';
import { cn } from '@/lib/utils';
import { WalletType } from '@/utils/wallet/types';

export enum TagType {
  Primary = 'Primary',
  Info = 'Info'
}
export const Tag = ({ children, type = TagType.Primary }: { children: ReactNode; type?: TagType }) => {
  const classes = useMemo(() => {
    const classes = ['flex items-center justify-center px-[8px] py-[2px] rounded-[16px] text-xs font-medium'];
    if (type === TagType.Primary) {
      classes.push('bg-primary-50 text-primary-900');
    }
    if (type === TagType.Info) {
      classes.push('bg-blue-50 text-blue-700');
    }
    return classes;
  }, [type]);
  return <span className={classNames(classes)}>{children}</span>;
};

const tagVariants = cva('bg-blue-50 hover:bg-blue/80 text-blue-700', {
  variants: {
    network: {
      [WalletType.EVM]: ['bg-blue-50 hover:bg-blue/80 text-blue-700'],
      [WalletType.Coinbase]: ['bg-blue-50 hover:bg-blue/80 text-blue-700'],
      [WalletType.OKX]: ['bg-blue-50 hover:bg-blue/80 text-blue-700'],
      [WalletType.BITCOIN]: ['bg-tangerine-25 hover:bg-tangerine/80 text-tangerine-400'],
      [WalletType.APTOS]: ['bg-gray-25 hover:bg-gray/80 text-gray-500'],
      [WalletType.SOLANA]: ['bg-darkMatter-25 hover:bg-darkMatter/80 text-purple-600'],
      [WalletType.TON]: ['bg-cyan-25 hover:bg-cyan/80 text-cyan-400'],
      [WalletType.PARTICLE]: ['bg-blue-50 hover:bg-blue/80 text-blue-700'],
      [WalletType.Cyber]: ['bg-blue-50 hover:bg-blue/80 text-blue-700'],
      [WalletType.StarkNet]: ['bg-slime-50 hover:bg-slime/80 text-slime-700'],
      [WalletType.WALLETCONNECT]: ['bg-blue-50 hover:bg-blue/80 text-blue-700'],
      [WalletType.Cardano]: ['bg-darkMatter-25 hover:bg-darkMatter/80 text-darkMatter-500']
    }
  }
});

export const NetworkTag = ({ network }: { network: WalletType }) => {
  return <Badge className={cn(tagVariants({ network }))}>{NETWORK_TYPE_DISPLAY[network]}</Badge>;
};
